// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_nm-0";
export var animationContainer = "_nm-1";
export var itemPrice = "_nm-a";
export var itemizedContent = "_nm-9";
export var itemizedHeader = "_nm-7";
export var itemizedRow = "_nm-8";
export var itemizedSection = "_nm-6";
export var modalContent = "_nm-2";
export var orderName = "_nm-3";
export var refundOption = "_nm-4";
export var refundOptionsContainer = "_nm-5";
export var shippingLabel = "_nm-b";
export var totalRow = "_nm-c";